export default {
    productBase:"/chaxiaoqu/",
}